import C from "../../../Constants";

const CustomTaskEdit = (() => {
  const buildCustomTaskEdit = () => {
    return {
      // イベント編集中はhasChangesイベントを無効にする
      suspendHasChangesEvent: true,
      // 削除ボタンを非表示
      editorConfig: {
        title: "Edit ",
        bbar: {
          items: {
            deleteButton: false,
          },
        },
      },
      items: {
        generalTab: {
          title: "設定",
          // 検討中・予定のセレクトボックスを追加
          items: {
            schedulingStatusField: {
              type: "combo",
              name: "scheduling_status",
              editable: false,
              disabled: true,
              label: "ステータス",
              items: [
                { value: C.SCHEDULING_STATUS.SCHEDULED, text: "予定" },
                { value: C.SCHEDULING_STATUS.PLANNING, text: "計画中" },
              ],
            },
            startDateField: {
              dateField: {
                editable: false,
              },
              timeField: {
                editable: false,
              },
            },
            endDateField: {
              dateField: {
                editable: false,
              },
              timeField: {
                editable: false,
              },
            },

            // その他のフィールドを非表示
            nameField: false,
            durationField: false,
            resourcesField: false,
            percentDoneField: false,
            effortField: false,
          },
        },
        // タブバーの設定
        // イベントの設定以外のタブを非表示
        predecessorsTab: false,
        successorsTab: false,
        advancedTab: false,
        notesTab: false,
      },
    };
  };

  const handleBeforeTaskEditShow = ({ editor, taskRecord }) => {
    // タイトル
    editor.title = `${taskRecord.resource.parent.name} ${taskRecord.resource.name} ${taskRecord.name}`;
    // 予定ステータスまたは新規追加されたレコードはセレクトボックス編集不可
    editor.widgetMap.schedulingStatusField.disabled =
      taskRecord.scheduling_status === C.SCHEDULING_STATUS.SCHEDULED ||
      taskRecord.isPhantom;
  };

  return {
    buildCustomTaskEdit,
    handleBeforeTaskEditShow,
  };
})();

export default CustomTaskEdit;
